export default __webpack_public_path__ + "static/media/KoCapaBtn.27ea7515.png";